import { FirebaseTimestampType, FirebaseDocRefType } from '../../firebase'

export type PointCardType = {
  brand_ref: FirebaseDocRefType
  name: string
  icon_url: string
  color: string
  status: PointCardStatusType
  expiration: PointCardExpiration | null // nullの場合は期限なし
  grades: PointCardGradeType[]
  condition: {
    initial_points: number
    amount_unit: number
    amount_points: number
  }
  actions: PointCardActionType[]
  note: string
  created_at: FirebaseTimestampType
  updated_at: FirebaseTimestampType
}

export const PointCardExpirationTypeMap = {
  no_limit: '期限なし',
  specified_date: '日付指定',
  from_last_acquired_point_date: '最終ポイント取得日から指定',
  from_acquired_date: '特典獲得日から指定',
} as const
export type PointCardExpirationType = keyof typeof PointCardExpirationTypeMap

export type PointCardExpiration = {
  expires_at: FirebaseTimestampType | null
  expiration_unit: PointCardExpirationUnitType | null
  expiration_period: number | null
}

export const PointCardExpirationUnit = {
  day: '日',
  month: '月',
  year: '年',
} as const
export type PointCardExpirationUnitType = keyof typeof PointCardExpirationUnit

export const PointCardStatus = {
  active: '公開中', // 購入時に新規発行を行う
  suspended: '下書き', // 新規発行を停止する
  deleted: '削除', // 論理削除状態
} as const
export type PointCardStatusType = keyof typeof PointCardStatus

export const PointCardAction = {
  sacri: 'sacri決済',
  store: '店頭決済',
} as const
export type PointCardActionType = keyof typeof PointCardAction

export type PointCardGradeType = {
  name: string
  threshold: number
}

export type PointCardState = {
  pointCard: PointCardType | undefined
}
